<!--
 * @Author: zql
 * @Date: 2020-03-13 15:29:14
 * @LastEditTime: 2020-06-02 14:35:50
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \enfry-components\packages\components\en-result\src\noAddress\no-address.vue
-->
<template>
  <div
    ref="NoAddress"
    class="noaddress"
  >
    <img
      slot="icon"
      class="icon-img"
      src="http://cdn.enfry.com/no-address11284.png"
      :alt="this.title"
    >
   <div class="title" v-html="title"></div>
    <div class="subtitle" v-html="subTitle"></div>
  </div>
</template>

<script>
export default {
  name: "NoAddress",
  props: {
    type: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: [String, Number],
      default: "normal"
    },
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: "暂无地址"
    }
  }

}
</script>
<style lang="scss" scoped>
  .noaddress {
    text-align: center;

    .icon-img {
      height: 82px;
      width: 120px;
    }
  }
</style>

